import React, { useMemo } from "react";

import { styled } from "@mui/material";

import { getMediaQuery } from "../../getMediaQuery";
import { QuantityButtonRenderer } from "../../QuantityButtonsView/types";
import { cls } from "../../util";
import { useQuantityButtonsContext } from "../context/QuantityButtonsContext";

interface QuantityButtonProps {
  className?: string;
  renderButton: QuantityButtonRenderer;
}

export const QuantityButtonsWrapper = ({
  renderButton,
  className,
}: QuantityButtonProps) => {
  const { widget, quantity } = useQuantityButtonsContext();

  const { buttons } = widget.variables;
  const selected = useMemo(
    () => buttons.findLast((b) => b.quantity <= quantity),
    [buttons, quantity]
  );
  if (widget.variant === "quantityButtonsWidgetCompact") {
    return (
      <CompactContainer
        className={cls("ig-volume-widget-container", className)}
      >
        {buttons.map((button, index): any =>
          renderButton({ button, selected: selected === button, index })
        )}
      </CompactContainer>
    );
  }
  return (
    <Container className={cls("ig-volume-widget-container", className)}>
      {buttons.map((button, index): any =>
        renderButton({ button, selected: selected === button, index })
      )}
    </Container>
  );
};

const Container = styled("div")(() => {
  const { hasMediaQuery, widget } = useQuantityButtonsContext();
  const { device } = widget;

  return {
    ...(hasMediaQuery ? getMediaQuery(widget) : undefined),
    boxSizing: "border-box",
    fontFamily: "inherit",
    margin: 12,
    display: widget.styles.appearance.layout === "row" ? "grid" : "flex",
    alignItems: "stretch", // or stretch
    flexWrap: "wrap",
    gap: widget.styles.appearance.spacing || "12px 8px",
    flexDirection: widget.styles.appearance.layout || "row",
    ...(widget.styles.appearance.layout === "row" && {
      gridTemplateColumns: "repeat(3, 33%)",
    }),
  };
});

const CompactContainer = styled("div")(() => {
  const { hasMediaQuery, widget } = useQuantityButtonsContext();
  const { device } = widget;

  return {
    ...(hasMediaQuery ? getMediaQuery(widget) : undefined),
    fontFamily: "inherit",
    margin: 12,
    display: "grid",
    boxSizing: "border-box",
    gridTemplateColumns:
      widget.styles.appearance.layout === "row"
        ? "repeat(auto-fit, minmax(78px, 1fr))"
        : "1fr 1fr",
    alignItems: "stretch", // or stretch
    flexWrap: "wrap",
    gap: widget.styles.appearance.spacing || "12px 8px",
    flexDirection: widget.styles.appearance.layout || "row",
  };
});
